var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.isDark}},[_c('v-main',{staticClass:"px-3 h-100"},[_c('router-view')],1),_c('ErrorNotifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }